import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import QuickExplainerSection from './components/QuickExplainerSection';
import TrustBannerSection from './components/TrustBannerSection';
import FooterSection from './components/FooterSection';
import Navigation from '../../components/ui/Navigation';
import LanguageToggle from '../../components/ui/LanguageToggle';

const HomePage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('EN');
  const navigate = useNavigate();

  // Initialize language from localStorage and listen for language changes
  useEffect(() => {
    // Check localStorage for saved language preference on page load
    const savedLanguage = localStorage.getItem('creditFixerLanguage');
    if (savedLanguage && (savedLanguage === 'EN' || savedLanguage === 'FR')) {
      setCurrentLanguage(savedLanguage);
    }

    // Listen for language change events from LanguageToggle
    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language);
    };

    window.addEventListener('languageChange', handleLanguageChange);

    // Cleanup event listener
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  const handleApplyNow = () => {
    navigate('/apply');
  };

  const handleCheckEligibility = () => {
    navigate('/apply');
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Language Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageToggle 
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Navigation */}
      <Navigation currentLanguage={currentLanguage} />

      {/* Hero Section with animated Mastercard */}
      <HeroSection 
        onApplyNow={handleApplyNow}
        onCheckEligibility={handleCheckEligibility}
        currentLanguage={currentLanguage}
      />

      {/* Trust Banner */}
      <TrustBannerSection currentLanguage={currentLanguage} />

      {/* Quick 3-Step Explainer */}
      <QuickExplainerSection currentLanguage={currentLanguage} />

      {/* Footer Section */}
      <FooterSection currentLanguage={currentLanguage} />
    </div>
  );
};

export default HomePage;